(function () {
  function initLabGuide(root) {
    var dialog = root.querySelector('[data-th-lab-guide-lightbox]');
    var dialogImg = dialog && dialog.querySelector('[data-th-lab-guide-lightbox-image]');
    var closeBtn = dialog && dialog.querySelector('[data-th-lab-guide-lightbox-close]');
    if (!dialog || !dialogImg) return;

    function openLightbox(src, alt) {
      dialogImg.src = src;
      dialogImg.alt = alt || '';
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    }

    function closeLightbox() {
      if (dialog.open) dialog.close();
      dialogImg.removeAttribute('src');
    }

    root.querySelectorAll('[data-th-lab-guide-zoom]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var fullSrc = trigger.getAttribute('data-full-src');
        var alt = trigger.getAttribute('data-image-alt') || '';
        if (fullSrc) openLightbox(fullSrc, alt);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeLightbox();
    });

    dialog.addEventListener('cancel', function () {
      dialogImg.removeAttribute('src');
    });
  }

  function initAll() {
    document.querySelectorAll('.th-lab-guide').forEach(initLabGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('.th-lab-guide');
    if (root) initLabGuide(root);
  });
})();
